/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * baseImgPath: 图片存放地址
 * identityUrl: 验证服务器地址
 * identityConfig: 验证服务器oidc配置
 * apiUrl: API服务器地址
 * 
 */
import { WebStorageStateStore } from 'oidc-client';
import storage from '@/common/storage';

let baseUrl = '';
let baseImgPath = "";
let identityUrl = '';
let apiUrl = '';
let jdyUrl = '';

/**
 * isTestProductEnv
 * 是否是测试发布环境
 *
 * 发布正式环境时候需要设为false打包
 */
let isTestProductEnv = false;

if (process.env.NODE_ENV == 'development') {
   //identityUrl = 'https://identity.jdy.xuna.site';
      identityUrl = 'http://localhost:5000';
    //apiUrl = 'https://api.jdy.xuna.site';
      apiUrl = 'http://localhost:5100';
     jdyUrl = "http://localhost:5800";
} else {
  if (isTestProductEnv) {
    identityUrl = 'https://identity.jdy.xuna.site';
    apiUrl = 'https://api.jdy.xuna.site';
    jdyUrl = "http://jdy.xuna.site";
  } else {
    identityUrl = 'https://identity.wezhan.cn';
    apiUrl = 'https://bcapi.wezhan.cn';
    jdyUrl = "http://bc.wezhan.cn";
  }
}

const host = window.location.origin;

const identityConfig = {
  authority: identityUrl,

  userStore: new WebStorageStateStore({ store: storage }),
  client_id: 'js',
  response_type: 'id_token token',
  scope: 'openid profile role jdy',

  redirect_uri: host + '/oidc/callback.html',
  silent_redirect_uri: host + '/oidc/silent.html',

  post_logout_redirect_uri: host + '/index.html',
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 5 * 60,
  automaticSilentRenew: true,
  filterProtocolClaims: true
};

export const environment = {
  baseUrl,
  baseImgPath,
  identityUrl,
  apiUrl,
  identityConfig,
  host,
  jdyUrl
}



// WEBPACK FOOTER //
// ./src/environments/environment.js